import React, { useEffect, useLayoutEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Select,
  MenuItem,
  Typography,
  Tabs,
  Tab,
  FormControl,
  TextField,
  InputAdornment,
  Popper,
  ClickAwayListener,
  Paper,
  Chip,
  Button,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { errorToast, successToast } from "../../helpers/toast";
import Pagination from "../../components/Pagination";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import {
  useAllOrdersMutation,
  useGetOrderCountMutation,
  useGetOrderCsvMutation,
  useUpdateOrderStatusMutation,
} from "../../services/order";
import Loader from "../../helpers/constants/Loader";
import { getFromStorage } from "../../constants/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/Translation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageOrder = () => {
  const { state } = useLocation();
  const t = useTranslation();
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const navigate = useNavigate();
  const [orderStatus] = useUpdateOrderStatusMutation();
  const [getCount] = useGetOrderCountMutation();
  const [orderCsv] = useGetOrderCsvMutation();
  const { pathname } = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount1] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [open1, setOpen1] = useState(false); // Control calendar visibility
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedChip, setSelectedChip] = useState("");
  const [month, setMonth] = useState(new Date());
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any>([]);
  const [count, setCount] = useState<any>("");
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });

  const [allOrders] = useAllOrdersMutation();

  const getAllOrders = async () => {
    setLoading(true);
    let body = {
      start: 1,
      length: 10,
      search: debouncedSearchTerm,
      order_type: value + 1,
      ...(range?.from
        ? { start_date: moment(range?.from).startOf("day") }
        : {}),
      ...(range?.to ? { end_date: moment(range?.to).startOf("day") } : {}),
    };

    try {
      const response = await allOrders(body).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        if (value == 0) {
          setCount1(response?.data?.total_records);
        } else if (value == 1) {
          setCount2(response?.data?.total_records);
        } else if (value == 2) {
          setCount3(response?.data?.total_records);
        }
        setRows(response.data.response_object);
        setTotalRecords(response?.data?.total_records);
        setTotalPages(Math.ceil(response?.data?.total_records / limit));
      } else {
        setLoading(false);
        setRows([]);
      }
    } catch (error: any) {
      setLoading(false);
      errorToast(error?.data?.message || "");
    }
  };

  const getOrderCsv = async () => {
    const body = {
      search: debouncedSearchTerm,
      order_type: value + 1,
      ...(range?.from
        ? { start_date: moment(range?.from).startOf("day") }
        : {}),
      ...(range?.to ? { end_date: moment(range?.to).startOf("day") } : {}),
    };
    try {
      const res = await orderCsv(body).unwrap();
      if (res?.status === 200) {
        window?.open(res?.file_urls);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const handleRequestStatus = async (status: any, id: string) => {
    const currentDate = new Date().toISOString(); // Get the current date in ISO format
    const statusValue = status.target.value;
    try {
      const body = {
        order_status: statusValue,
        ...(statusValue === "2" ? { in_progress_date: currentDate } : {}),
        ...(statusValue === "3" ? { shipping_date: currentDate } : {}),
        ...(statusValue === "4" ? { delivered_date: currentDate } : {}),
      };

      const response = await orderStatus({
        body,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        const updatedData = rows?.map((x: any) => {
          if (x.id === id) {
            return {
              ...x,
              order_status: Number(status.target.value),
            };
          }
          return x;
        });
        setRows(updatedData);
        successToast("Status updated successfully");
      } else {
        errorToast("Please try again");
      }
    } catch {
      errorToast("Something went wrong");
    }
  };

  useEffect(() => {
    getAllOrders();
  }, [value, debouncedSearchTerm, range?.from, range?.to]);

  const handleClose = () => {
    setOpen1(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
      if (
        selectedRange.from !== undefined &&
        selectedRange.to !== undefined &&
        selectedRange.from !== selectedRange.to
      ) {
        setOpen1(false);
      }
    }
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  const getOrderCount = async () => {
    const body = {
      search: debouncedSearchTerm,
      ...(range?.from
        ? { start_date: moment(range?.from).startOf("day") }
        : {}),
      ...(range?.to ? { end_date: moment(range?.to).startOf("day") } : {}),
    };
    try {
      const res = await getCount(body).unwrap();
      if (res?.status === 200) {
        setCount(res?.data);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  useLayoutEffect(() => {
    if (state) {
      setValue(state);
    }
  }, []);

  useEffect(() => {
    getOrderCount();
  }, [range?.from, range?.to, debouncedSearchTerm]);

  return (
    <div>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageOrders}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header" marginBottom={"20px"}>
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
              <div className="control_group" style={{ width: 250 }}>
                <TextField
                  // label="Select Date Range"
                  variant="outlined"
                  hiddenLabel
                  className="text_field-range"
                  fullWidth
                  onClick={handleClick}
                  value={getFormattedRange()}
                  placeholder="Select Date Range"
                  InputProps={{
                    readOnly: true,
                    endAdornment: range?.from ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setRange({
                              from: undefined,
                              to: undefined,
                            });
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : (
                      <InputAdornment position="end">
                        <IconButton>
                          <CalendarTodayIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <Popper
                open={open1}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal
                style={{
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <Paper
                    elevation={3}
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <div
                      style={{
                        padding: 16,
                        borderRadius: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <Chip
                          label="Last Week"
                          variant={
                            selectedChip === "lastWeek" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastWeek")}
                        />
                        <Chip
                          label="Last Month"
                          variant={
                            selectedChip === "lastMonth" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastMonth")}
                        />
                        <Chip
                          label="Last Year"
                          variant={
                            selectedChip === "lastYear" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastYear")}
                        />
                      </div>

                      <DayPicker
                        className="react-day-picker"
                        mode="range"
                        selected={range}
                        onSelect={handleSelect}
                        // numberOfMonths={10}
                        month={month}
                        onMonthChange={handleMonthChange}
                        // styles={{
                        //   months: { display: "flex", gap: "16px" },
                        //   month: { margin: 0 },
                        // }}
                      />
                    </div>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </Box>

            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                disabled={rows?.length === 0 ? true : false}
                onClick={getOrderCsv}
              >
                <FileDownloadIcon /> {t.main.exportCsv}
              </Button>
            </Box>
          </Box>
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab
                label={`${t.main.onGoing}${count?.Ongoing ? ` (${count?.Ongoing})` : ""}`}
                {...a11yProps(0)}
              />
              <Tab
                label={`${t.main.completed}${count?.Complete ? ` (${count?.Complete})` : ""}`}
              />
              <Tab
                label={`${t.main.rejected}${count?.Cancel ? ` (${count?.Cancel})` : ""}`}
              />
            </Tabs>

            <CustomTabPanel value={value} index={0}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.orderTrackId}</TableCell>
                      <TableCell>{t.main.userName}</TableCell>
                      <TableCell>{t.main.subTotal}</TableCell>
                      <TableCell>{t.main.totalCost}</TableCell>
                      <TableCell>{t.main.deliveryFees}</TableCell>
                      <TableCell>{t.main.shippingAddress}</TableCell>
                      <TableCell>{t.main.contact}</TableCell>
                      <TableCell>{t.main.orderStatus}</TableCell>
                      <TableCell>{t.main.paymentStatus}</TableCell>

                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          {t.error.noData}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.id}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>

                          <TableCell>#{row?.order_track_id || "-"}</TableCell>
                          <TableCell>{row?.user || "-"}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.sub_total || "0"}`}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.total_cost_pay || "0"}`}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.delivery_fees || "0"}`}</TableCell>
                          <TableCell>
                            {row?.address.business_address || "-"}
                            <br />
                            {row?.address.city}
                          </TableCell>
                          <TableCell>
                            {`${row?.country_code} ${row?.phone_no}`}
                          </TableCell>

                          <TableCell>
                            <FormControl sx={{ width: "100%" }}>
                              <Select
                                value={String(row?.order_status)}
                                onChange={(val: any) =>
                                  handleRequestStatus(val, row?.id)
                                }
                                displayEmpty
                              >
                                <MenuItem
                                  value={"1"}
                                  disabled={
                                    row?.order_status !== "1" &&
                                    row?.order_status !== "2"
                                  }
                                >
                                  {t.main.orderPlaced}
                                </MenuItem>
                                <MenuItem
                                  value={"2"}
                                  disabled={
                                    row?.order_status < "1" ||
                                    row?.order_status > "2"
                                  }
                                >
                                  {t.main.inProgress}
                                </MenuItem>
                                <MenuItem
                                  value={"3"}
                                  disabled={
                                    row?.order_status < "2" ||
                                    row?.order_status > "3"
                                  }
                                >
                                  {t.main.shipping}
                                </MenuItem>
                                <MenuItem
                                  value={"4"}
                                  disabled={row?.order_status < "3"}
                                >
                                  {t.main.delivered}
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell>{"Done"}</TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-Order/details/${row?.id}`)
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>

                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.orderTrackId}</TableCell>
                      <TableCell>{t.main.userName}</TableCell>
                      <TableCell>{t.main.subTotal}</TableCell>
                      <TableCell>{t.main.totalCost}</TableCell>
                      <TableCell>{t.main.deliveryFees}</TableCell>
                      <TableCell>{t.main.shippingAddress}</TableCell>
                      <TableCell>{t.main.contact}</TableCell>
                      <TableCell>{t.main.orderStatus}</TableCell>
                      <TableCell>{t.main.paymentStatus}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          {t.error.noData}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.id}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>

                          <TableCell>#{row?.order_track_id || "-"}</TableCell>
                          <TableCell>{row?.user || "-"}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.sub_total || "0"}`}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.total_cost_pay || "0"}`}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.delivery_fees || "0"}`}</TableCell>
                          <TableCell>
                            {row?.address.business_address || "-"}
                            <br />
                            {row?.address.city}
                          </TableCell>
                          <TableCell>
                            {`${row?.country_code} ${row?.phone_no}`}
                          </TableCell>
                          <TableCell>{"Done"}</TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-Order/details/${row?.id}`)
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>

                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.orderTrackId}</TableCell>
                      <TableCell>{t.main.userName}</TableCell>
                      <TableCell>{t.main.subTotal}</TableCell>
                      <TableCell>{t.main.totalCost}</TableCell>
                      <TableCell>{t.main.deliveryFees}</TableCell>
                      <TableCell>{t.main.shippingAddress}</TableCell>
                      <TableCell>{t.main.contact}</TableCell>
                      <TableCell>{t.main.orderStatus}</TableCell>
                      <TableCell>{t.main.paymentStatus}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          {t.error.noData}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.id}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>

                          <TableCell>#{row?.order_track_id || "-"}</TableCell>
                          <TableCell>{row?.user || "-"}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.sub_total || "0"}`}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.total_cost_pay || "0"}`}</TableCell>
                          <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.delivery_fees || "0"}`}</TableCell>
                          <TableCell>
                            {row?.address.business_address || "-"}
                            <br />
                            {row?.address.city}
                          </TableCell>
                          <TableCell>
                            {`${row?.country_code} ${row?.phone_no}`}
                          </TableCell>

                          {/* <TableCell>
                            {"shipped: 17/10/24"}
                            <br />
                            {"dispatched: 19/10/24"}
                          </TableCell> */}
                          <TableCell>{"Done"}</TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-Order/details/${row?.id}`)
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>

                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
          </Box>
        </Card>
        {rows?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={rows}
            page={page}
            onPageChange={setPage}
            totalPages={totalPages}
            setTotalPages={setTotalPages}
            limit={limit}
            setLimit={setLimit}
            totalRecords={totalRecords}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ManageOrder;
